import React, { useEffect, useState } from "react";
import { Cell, Label, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";
import axiosInstance from "../../../../../Services/axiosCommon";
import { useNavigate } from "react-router-dom";

export default function POToSuppliersProDash() {
  const [params, setParams] = useState({ period: "monthly" });
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const COLORS = ["#F59E0B", "#EC4899", "#8B5CF6", "#10B981"];

  async function getData() {
    setLoading(true);
    try {
      const res = await axiosInstance.get(`/dashboard/PO-pending`, { params });
      setData(res?.data || {});
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getData();
  }, [params]);

  const status = [
    { name: "Pending", value: data.pending || 0, status: "Pending" },
    { name: "Reviewed", value: data.reviewed || 0, status: "Reviewed" },
    { name: "Verified", value: data.verified || 0, status: "Verified" },
    { name: "Approved", value: data.approved || 0, status: "Approved" },
  ];

  const handleSliceClick = (statusName) => {
    const path = "/procurement/purchase-order";
    navigate(path, { state: { approvalStatus: statusName } });
  };

  const sumValue = status.reduce((sum, item) => sum + item?.value, 0);

  return (
    <div className="bg-white p-5 rounded-2xl border border-gray-100 shadow-[0_4px_25px_rgba(0,0,0,0.04)] transition-all duration-300 flex flex-col justify-between">
      <div className="flex items-center justify-between pb-3 border-b border-gray-100 mb-3">
        <div className="flex items-center space-x-2">
          <div className="w-7 h-7 rounded-lg bg-blue-50 flex items-center justify-center text-blue-600">
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <h3 className="text-sm font-semibold text-gray-800">Purchase Order Approvals</h3>
        </div>
        <span className="text-xs font-bold px-2.5 py-0.5 rounded-full bg-blue-50 text-blue-700 border border-blue-200/50">
          {data?.total || 0} Total
        </span>
      </div>

      {loading ? (
        <div className="h-52 flex items-center justify-center animate-pulse">
          <div className="h-36 bg-gray-100 rounded-xl w-full"></div>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-12 gap-3 items-center flex-1">
          {/* Donut Chart */}
          <div className="md:col-span-5 relative flex justify-center items-center h-44">
            {sumValue > 0 ? (
              <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                  <Pie
                    data={status}
                    cx="50%"
                    cy="50%"
                    innerRadius={38}
                    outerRadius={58}
                    paddingAngle={3}
                    dataKey="value"
                    stroke="none"
                    style={{ cursor: "pointer" }}
                    onClick={(e) => handleSliceClick(e.status)}
                  >
                    {status.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                    ))}
                    <Label
                      value={`${data?.total || 0}`}
                      position="center"
                      style={{ fontSize: "15px", fontWeight: "bold", fill: "#1F2937" }}
                    />
                  </Pie>
                  <Tooltip
                    contentStyle={{
                      backgroundColor: "#1F2937",
                      borderRadius: "8px",
                      color: "#FFF",
                      border: "none",
                      fontSize: "11px",
                    }}
                  />
                </PieChart>
              </ResponsiveContainer>
            ) : (
              <div className="text-center text-gray-400 text-xs font-medium">No PO Data</div>
            )}
          </div>

          {/* Status Breakdown Grid */}
          <div className="md:col-span-7 grid grid-cols-2 gap-2 max-h-48 overflow-y-auto pr-1">
            {status.map((item, idx) => {
              const color = COLORS[idx % COLORS.length];
              return (
                <button
                  key={idx}
                  onClick={() => handleSliceClick(item.status)}
                  className="p-2.5 rounded-xl bg-gray-50/70 hover:bg-gray-100/80 text-left transition-all duration-200"
                >
                  <div className="flex items-center space-x-2 mb-1">
                    <span className="w-2 h-2 rounded-full" style={{ backgroundColor: color }}></span>
                    <span className="text-[11px] font-medium text-gray-600">{item.name}</span>
                  </div>
                  <p className="text-sm font-bold text-gray-900">{item.value}</p>
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

export function NODataChart() {
  return (
    <div className="w-full flex justify-center items-center h-40">
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={[{ name: "No Data", value: 100 }]}
            cx="50%"
            cy="50%"
            innerRadius={35}
            outerRadius={55}
            fill="#F3F4F6"
            dataKey="value"
            stroke="none"
          >
            <Label
              value={0}
              position="center"
              style={{ fontSize: "14px", fontWeight: "bold", fill: "#9CA3AF" }}
            />
          </Pie>
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}
